var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"manual-container"},[_c('liaison',{attrs:{"data":_vm.liaison,"notPreview":_vm.notPreview,"isH5":_vm.isH5}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }